export default {
  open: false,
  password: '',
  confirmPassword: '',
  token: '',
  success: false,
  loading: false,
  errors: {},
};
